module.exports = __webpack_public_path__ + "static/img/notice2.e19d5c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup/concierge/20250613/notice2.png
// module id = Wpi5
// module chunks = 0